<template>
  <div class="mb">
    <p class="small" style="margin-bottom: 0.5em">{{ field.label }}</p>
    <div v-if="field.type === 'select'" class="df">
      <div class="mr" v-for="option in field.options" :key="option.value">
        <input
          disabled
          type="radio"
          :name="field.label"
          :value="option.value"
          :checked="field.value === option.value ? 'checked' : null"
        >
        <label 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          :for="option.label" 
          class="c-accent"
        >&nbsp;{{ option.label }}</label
        >
      </div>
    </div>
    <p 
      v-else-if="field.type === `tel`" 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="c-accent">
      {{ phoneNumber(field.value, `US`).getNumber("international") }}
    </p>
    <p 
      v-else-if="field.label === 'First Name'" 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="c-accent">{{ titleCase(field.value) }}</p>
    <p 
      v-else-if="field.label === 'Last Name'" 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="c-accent">{{ titleCase(field.value) }}</p>
    <p 
      v-else 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="c-accent ">{{ field.value }}</p>
    <hr class="mt-tiny" >
  </div>
</template>

<script>
import phoneNumber from 'awesome-phonenumber';
import { titleCase } from 'utils/titleCase';

// Vuex
import { mapGetters } from 'vuex';


export default {
  name: 'module-read-only-form',

  props: {
    field: Object,
  },
  

  data() {
    return {
      phoneNumber,
      titleCase,
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
  },
};
</script>



// WEBPACK FOOTER //
// ReadOnlyForm.vue?7a3cb730